import { render, staticRenderFns } from "./GraficoPerimetro.vue?vue&type=template&id=6fac4b9f&scoped=true"
import script from "./GraficoPerimetro.vue?vue&type=script&lang=js"
export * from "./GraficoPerimetro.vue?vue&type=script&lang=js"
import style0 from "./GraficoPerimetro.vue?vue&type=style&index=0&id=6fac4b9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fac4b9f",
  null
  
)

export default component.exports